module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', _vm._l((_vm.errors), function(errorKey, index) {
    return _c('span', {
      key: index
    }, _vm._l((errorKey), function(error, errorIndex) {
      return _c('span', {
        key: errorIndex
      }, [_vm._v("\n            " + _vm._s(error) + "\n            "), _c('br')])
    }), 0)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d83ad23a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ErrorList.vue
// module id = 1342
// module chunks = 1